import { styled } from '@mui/material/styles'

export const BestFitResultsList = styled('div', {
  name: 'BestFitResultsList',
  slot: 'Root',
  skipSx: true,
  skipVariantsResolver: true,
})(() => ({}))
